import { FC, useCallback, useState } from 'react';
import Spacing from 'src/styles/layouts/Spacing';
import NGIcon from 'src/styles/theme/components/NGIcon';
import { EIcon } from 'src/styles/theme/components/NGIcon/NGIcon.enum';
import NGSquareButton from 'src/styles/theme/components/NGSquareButton';
import { ESize, ETextColor } from 'src/styles/theme/utils/enums';
import { StyledButton, StyledIconsContainer, StyledOnHoverContainer, StyledSpan } from './CopyOnClick.styles';
import { ICopyOnClick } from './CopyOnClick.type';

export const copy = async (value: string) => {
	try {
		const copyText = document.createElement('input');

		// include hidden chars
		copyText.setAttribute('value', value);

		/* Select the text field */
		copyText.select();
		copyText.setSelectionRange(0, 99999); /* For mobile devices */

		/* Copy the text inside the text field */
		navigator.clipboard.writeText(copyText.value);
		return true;
	} catch {
		return false;
	}
};

// add copy icon and copy to clipboard on click
const CopyOnClick: FC<ICopyOnClick> = ({
	children,
	value,
	visibleOnHover = false,
	fullWidth = false,
	textTruncate = false,
	padding = ESize.unset,
	paddingBottom,
	paddingTop,
	paddingLeft,
	paddingRight,
	paddingX,
	paddingY,
	...otherProps
}) => {
	const [isCopying, setIsCopying] = useState(false);

	const handleClick = useCallback(() => {
		copy(value);
		setIsCopying(true);

		setTimeout(() => {
			setIsCopying(false);
		}, 1500);
	}, [value]);

	if (visibleOnHover) {
		return (
			<StyledOnHoverContainer>
				{children}
				<NGSquareButton size={ESize.s} onClick={handleClick} icon={EIcon.unset} marginBottom={ESize['4xs']}>
					<StyledIconsContainer isActive={isCopying}>
						<NGIcon size={ESize.s} type={EIcon.copy} color={ETextColor.gold} />
						<NGIcon size={ESize.s} type={EIcon.check} color={ETextColor.gold} />
					</StyledIconsContainer>
				</NGSquareButton>
			</StyledOnHoverContainer>
		);
	}
	return (
		<StyledButton
			onClick={handleClick}
			padding={padding}
			paddingX={paddingX}
			paddingY={paddingY}
			paddingBottom={paddingBottom}
			paddingTop={paddingTop}
			paddingLeft={paddingLeft}
			paddingRight={paddingRight}
			fullWidth={fullWidth}
			{...otherProps}
		>
			<StyledSpan textTruncate={textTruncate}>{children}</StyledSpan>

			<Spacing size={ESize['4xs']} />

			<StyledIconsContainer isActive={isCopying}>
				<NGIcon size={ESize.s} type={EIcon.copy} color={ETextColor.gold} />
				<NGIcon size={ESize.s} type={EIcon.check} color={ETextColor.gold} />
			</StyledIconsContainer>
		</StyledButton>
	);
};

export { CopyOnClick };
